{
  "Administrator": "Beheerder:",
  "AdministratorRole": "Beheerdersrol:",
  "AdministratorLanguage_ServiceNotification": "Servicemelding:",
  "AdministratorLanguage_ConcurrentSignins": "Gelijktijdige aanmeldingen toegestaan:",
  "NAME": "AdministratorLanguage"
}